import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccordionComponent } from '../../../../../shared/components/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../shared/components/accordion/accordion-item.component';

@Component({
  selector: 'app-product-trade-policies',
  standalone: true,
  imports: [CommonModule, AccordionComponent, AccordionItemComponent],
  templateUrl: './product-trade-policies.component.html',
})
export class ProductTradePoliciesComponent {
  @Input({ required: true }) stores!: any[];
}
